/**
 * ScreenShakeSystem - Camera shake effect for powerful shots and goals.
 * Covers task 6.13 (screen shake on powerful shots).
 */

import * as BABYLON from "babylonjs";

export class ScreenShakeSystem {
  private _camera: BABYLON.FollowCamera;
  private _shakeTimer = 0;
  private _shakeIntensity = 0;
  private _originalHeightOffset = 0;
  private _originalRotationOffset = 0;

  constructor(camera: BABYLON.FollowCamera) {
    this._camera = camera;
  }

  /**
   * Trigger a screen shake effect.
   * @param intensity 0-1 shake intensity
   * @param duration seconds
   */
  shake(intensity: number, duration: number): void {
    // Only increase if new shake is stronger
    if (intensity > this._shakeIntensity || this._shakeTimer <= 0) {
      this._shakeIntensity = Math.min(1, intensity);
      this._shakeTimer = duration;
      this._originalHeightOffset = this._camera.heightOffset;
      this._originalRotationOffset = this._camera.rotationOffset;
    }
  }

  update(dt: number): void {
    if (this._shakeTimer <= 0) return;

    this._shakeTimer -= dt;

    if (this._shakeTimer <= 0) {
      // Reset camera
      this._camera.heightOffset = this._originalHeightOffset;
      this._shakeTimer = 0;
      return;
    }

    // Fade out shake over time
    const fade = this._shakeTimer > 0 ? this._shakeTimer : 0;
    const maxOffset = this._shakeIntensity * 0.8 * fade;

    // Random jitter applied to camera height and rotation
    const shakeX = (Math.random() - 0.5) * 2 * maxOffset;
    const shakeY = (Math.random() - 0.5) * 2 * maxOffset;

    this._camera.heightOffset = this._originalHeightOffset + shakeY;
    this._camera.rotationOffset = this._originalRotationOffset + shakeX * 2;
  }

  /** Shake for a goal celebration */
  goalShake(): void {
    this.shake(0.8, 0.5);
  }

  /** Shake for a powerful shot */
  shotShake(power: number): void {
    if (power > 0.7) {
      this.shake(power * 0.4, 0.25);
    }
  }
}
